import { isGGI, isGFD } from "../actions/root_url";

export const getKeysMap = (key, keysMapObj) => keysMapObj[key] || key;
export const getSortVal = (key, desc) => {
  if (desc) {
    key = `-${key}`
  }
  return key
}
/**
 * Moves a column to the specified position in the table
 * @param {Array<Object>} columns
 * @param {Object<string: any>} condition
 * @param {Number} position
 * @return {Array<Object>} columns
 */
export const moveColumnToPosition = (columns, condition, position = -1) => {
  const [[key, value]] = Object.entries(condition);
  const index = columns.findIndex(column => column[key] === value);
  if (index !== -1) {
    const [column] = columns.splice(index, 1)
    if (position === -1) {
      columns.push(column);
    } else {
      columns.splice(position, 0, column);
    }
  }
  return columns;
}
const ggiAllCompaniesWhiteList = ['/purchaseOrder', '/salesOrders', '/salesInvoice', '/salesPerformanceReport', '/inventoriesnew','/customerStatementMain', '/customerStatementMain/'];
export const isAllCompaniesWhiteList = (path) => {
  if(!path || path == null || path == NaN) {
    return false;
  }
  let isInside = false;
  if(isGGI || isGFD) {
    ggiAllCompaniesWhiteList.map(item => {
      if(path.endsWith(item)) {
        isInside = true;
      }
    })
  }
  return isInside;
}

export const isProductPage = (path) => { // is product file
  if(!path || path == null || path == NaN) {
    return false;
  }
  if(path.indexOf('/products/') != -1 && !path.endsWith('/products/categories') && !path.endsWith('/products/groups')) {
    return true;
  }
  return false;
}


function splitStringByLength(str, len) {
  if (str.length <= len) return [str];
  else return [str.substring(0, len)].concat(splitStringByLength(str.substring(len), len));
}
export const wrapLongWord = (text, maxWidth) => {
  let splitArray = splitStringByLength(text, maxWidth);
  if(splitArray.length == 1) {
    return splitArray[0];
  }
  let tx = '';
  splitArray.map((item, index) => {
    if(index == splitArray.length-1) {
      tx += item;
    } else {
      tx += item + '\n';
    }
  });
  return tx;
}


// WEBPACK FOOTER //
// ./master/jsx/utils/index.js